import http from '../request/request.js';

export default {
  // 登录
  UsrLogin:function(params){
		return http.fetchPost('/Usr/UsrLogin', params, 'back_ul');
	},

  // 修改密码
  UsrUpdPwd:function(params){
		return http.fetchPost('/Usr/UsrUpdPwd', params, 'back_ul');
	},

  // 登出
  UsrLogout:function(params){
		return http.fetchPost('/Usr/UsrLogout', params, 'back_ul');
	},
  //心贴发单列表（客户信息列表）
	getHeartOrderList:function(params){
		return http.fetchPost('/Record/ProMnagerHeartOrderList', params)
	},
	//修改订单上传信息
	updateHeartOrder:function(params){
		return http.fetchPost('/Record/Update', params)
	},
  //删除订单
	delHeartOrder:function(params){
		return http.fetchPost('/Record/Delete', params)
	},
  getCodeList(params){
    return http.fetchPost('/Pub/GetMiscodeList', params)
  },
  getHeartCodeList(params){
    return http.fetchPost('/Pub/DocHeartCodeList', params)
  },
  ExportHeartOrderData(params){
    return http.fetchPost('/Record/ExportHeartOrderData', params)
  },
  //心贴获取待审核列表
  OrderHeartMatchList: function (params) {
      return http.fetchPost('/HeartRecord/HeartRecordWaitList', params)
  },
  //获取绘制心电图地址
  getHeartPicUrl(params) {
      return http.fetchPost('/Pub/CreateHeartHttp', params)
  },
  // 操作记录
  GetLogs: function (params) { // 从mgr改成record
    return http.fetchPost('/StatusLog/GetLogs', params, 'record')
  },
  // 记录列表
  HeartRecordList:function(params){
		return http.fetchPost('/Record/ProManagerOrderInfoList', params)
	},
  // 批量下载报告
  HeartRecordDownload:function(params){
		return http.fetchPost('/2016-08-15/proxy/pdfcache.LATEST/ULInfPdfDownFu/', params,'downLoad')
	},
  // 获取枚举常量
  GetConst:function(params){
		return http.fetchPost('/Const/GetConst', params,'back_ul')
	},

}



// WEBPACK FOOTER //
// ./src/service/ApiService.js